// extracted by mini-css-extract-plugin
export default {"container":"peopleLoveUs_container__xRniH","heading":"peopleLoveUs_heading__sCdwM","swiperContainer":"peopleLoveUs_swiperContainer__vNU2J"};